(function () {
  'use strict';

  function factory(
    $http,
    THEME_BASE_PATH,
    THEME_TITLE,
    OPTIONS_PATH
  ) {
    'ngInject';

    var appState = {
      room: {
        selection: null,
      },
      fixture: {
        selection: null,
      },
      base: {
        selection: null,
      },
      type: {
        selection: null,
      },
      lumen: {
        selection: null,
      },
      watt: {
        selection: null,
      },
      del: {
        selection: null,
      },
      kelvins: {
        selection: null,
      },
      popular: {
        type: null,
        lumen: null,
        kelvin: null
      },
      hasBeenReset: false
    };

    var oldState = {};
    var json;

    $http
      .get(THEME_BASE_PATH + THEME_TITLE + OPTIONS_PATH)
      .then(function (response) {
        json = response.data;
      });

    return {
      get rooms() {
        return json.roomOptions;
      },
      get fixtures() {
        var fixtureFilter = json.roomOptions
          // eslint-disable-next-line es5/no-es6-methods
          .find(function (item) {
            return appState.room.selection === item.translateKey;
          })
          .filter;

        return json.fixtureOptions.filter(function (fixture) {
          return fixtureFilter.indexOf(fixture.translateKey) !== -1;
        });
      },
      get bases() {
        // eslint-disable-next-line es5/no-es6-methods
        var baseOptions = json.fixtureOptions.find(function (item) {
          return appState.fixture.selection === item.translateKey;
        }).filter.map(function (baseId) {
          // eslint-disable-next-line es5/no-es6-methods
          var specificOption = json.typeOptions.find(function (item) {
            return baseId === item.translateKey;
          });
          return specificOption;
        });

        return baseOptions;
      },
      get types() {
        // eslint-disable-next-line es5/no-es6-methods
        var typeOptions = json.typeOptions.find(function (item) {
          return appState.base.selection === item.translateKey;
        }).filter.map(function (baseId) {
          // eslint-disable-next-line es5/no-es6-methods
          var specificOption = json.lumenOptions.find(function (item) {
            return baseId === item.translateKey;
          });
          return specificOption;
        });

        return typeOptions;
      },

      get lumens() {
        // eslint-disable-next-line es5/no-es6-methods
        var typeOptions = json.lumenOptions.find(function (item) {
          return appState.type.selection === item.translateKey;
        });

        var lumenItems = typeOptions.items.map(function (baseId, index) {
          baseId.id = index;
          baseId.translateKey = baseId.lumen;
          return baseId;
        });

        return lumenItems;
      },

      get kelvins() {
        var currentLumen = this.lumens;

        // eslint-disable-next-line es5/no-es6-methods
        var kelvinOption = currentLumen.find(function (item) {
          return appState.lumen.selection === item.translateKey;
        });

        if (kelvinOption.watts) {
          this.wattSelection = kelvinOption.watts;
        }
        if (kelvinOption.del) {
          this.delSelection = kelvinOption.del;
        }
        return kelvinOption.kelvin;
      },

      get kelvinsAsPopular() {
        var kelvinList = this.kelvins;

        // eslint-disable-next-line es5/no-es6-methods
        var kelvinOption = kelvinList.find(function (item) {
          return item.popular;
        });
        return !!kelvinOption;
      },

      get allState() {
        return appState;
      },

      get allOlderState() {
        appState = oldState;
        return appState;
      },

      get popularType() {
        var popularType = '';
        var i = 0;
        // eslint-disable-next-line es5/no-es6-methods
        var typeOptions = json.typeOptions.find(function (item) {
          return appState.base.selection === item.translateKey ? item.filter : null;
        }).filter.map(function (baseId) {
          // eslint-disable-next-line es5/no-es6-methods
          var specificOption = json.lumenOptions.find(function (item) {
            return baseId === item.translateKey && item.popular && item.popular === true;
          });
          return specificOption && specificOption.translateKey;
        });

        for (i = 0; i < typeOptions.length; i += 1) {
          if (typeOptions[i]) {
            popularType = typeOptions[i];
            appState.popular.type = popularType;
          }
        }

        return popularType;
      },

      get popularLumen() {
        var popularLumen = '';
        var i = 0;

        // eslint-disable-next-line es5/no-es6-methods
        var typeOptions = json.lumenOptions.find(function (item) {
          return appState.popular.type === item.translateKey;
        });

        var lumenItems = typeOptions.items.map(function (singleLumen) {
          return singleLumen.popular && singleLumen.lumen;
        });

        for (i = 0; i < lumenItems.length; i += 1) {
          if (lumenItems[i]) {
            popularLumen = lumenItems[i];
            appState.popular.lumen = popularLumen;
          }
        }

        return popularLumen;
      },

      get popularKelvins() {
        var popularKelvins = '';
        var kelvinItems = [];
        var i = 0;

        // eslint-disable-next-line es5/no-es6-methods
        var typeOptions = json.lumenOptions.find(function (item) {
          return appState.popular.type === item.translateKey;
        });

        var lumenItems = typeOptions.items.map(function (singleLumen) {
          return singleLumen.popular && singleLumen.kelvin;
        });

        // Strip empty element from array
        lumenItems = lumenItems.filter(function (object) {
          return object !== undefined;
        });

        kelvinItems = lumenItems.length === 1 && lumenItems[0].map(function (singleKelvin) {
          return singleKelvin.popular && singleKelvin;
        });

        for (i = 0; i < kelvinItems.length; i += 1) {
          if (kelvinItems[i]) {
            popularKelvins = kelvinItems[i];
            appState.popular.kelvin = popularKelvins;
          }
        }

        return popularKelvins;
      },

      set roomSelection(selection) {
        appState.room.selection = selection;
        appState.hasBeenReset = false;
        appState.fixture.selection = null;
      },
      get roomSelection() {
        return appState.room.selection;
      },

      set fixtureSelection(selection) {
        appState.fixture.selection = selection;
        appState.base.selection = null;
      },
      get fixtureSelection() {
        return appState.fixture.selection;
      },

      set baseSelection(selection) {
        appState.base.selection = selection;
      },
      get baseSelection() {
        return appState.base.selection;
      },

      set typeSelection(selection) {
        appState.type.selection = selection;
      },
      get typeSelection() {
        return appState.type.selection;
      },

      set lumenSelection(selection) {
        appState.lumen.selection = selection;
      },
      get lumenSelection() {
        return appState.lumen.selection;
      },

      set wattSelection(selection) {
        appState.watt.selection = selection;
      },
      get wattSelection() {
        return appState.watt.selection;
      },
      set delSelection(selection) {
        appState.del.selection = selection;
      },
      get delSelection() {
        return appState.del.selection;
      },

      set kelvinsSelection(selection) {
        appState.kelvins.selection = selection;
      },
      get kelvinsSelection() {
        return appState.kelvins.selection;
      },
      reset: function () {
        oldState = appState;
        appState = {
          room: {
            selection: null,
          },
          fixture: {
            selection: null,
          },
          base: {
            selection: null,
          },
          type: {
            selection: null,
          },
          lumen: {
            selection: null,
          },
          watt: {
            selection: null,
          },
          del: {
            selection: null,
          },
          kelvins: {
            selection: null,
          },
          popular: {
            type: null,
            lumen: null,
            kelvin: null
          },
          hasBeenReset: true,
        };
      },
    };
  }

  angular
    .module('hq.tools.lighting')
    .factory('hqTLightingOptions', factory);
}());
